import { useEffect, useState } from "react";

import BaselineMaps from "../../gpa_maps/BaselineMaps";
import InfoWrappedMaps from "../../gpa_maps/InfoWrappedMaps";
import { getFnFpError } from "@utils";
import { useTranslation } from "react-i18next";

export default function BaselineSection(props) {
  const { t } = useTranslation();
  const [test, setTest] = useState(null);
  const [eye, setEye] = useState(null);
  const [type, setType] = useState(null);
  const [meanPsd, setMeanPsd] = useState(0);
  const [meanDeviation, setMeanDeviation] = useState(0);
  const [ntdGs, setNtdGs] = useState([]);
  const [npdGs, setNpdGs] = useState([]);
  const [vfi, setVfi] = useState(0);
  const [ght, setGht] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!props.test) return;
    setTest(props.test);
    setEye(props.test?.eye ?? null);
    setType(props.test?.testType ?? null);
  }, [props]);

  useEffect(() => {
    if (!test) return;
    setNtdGs(test.ntdGs);
    setNpdGs(test.npdGs);
    setMeanDeviation(test.md);
    setMeanPsd(test.psd);
    setVfi(test.vfi);
    setGht(test.ght);
    setReady(true);
  }, [test]);

  return (
    ready && (
      <InfoWrappedMaps
        date={new Date(test.startDate).toDateString()}
        behaviour={t("TestController.testBehaviour_" + test.testBehaviour)}
        ght={ght}
        lowReliability={false}
        vfi={vfi}
        psd={meanPsd}
        md={meanDeviation}
        half={props.halfMaps}
        fovea={test.fovea}
        w={"100%"}
        fl={
          test.blindSpotTotal
            ? `${Number(test["blindSpotSeen"])}/${Number(test["blindSpotTotal"])}`
            : ""
        }
        fp={getFnFpError(test, "fp")}
        fn={getFnFpError(test, "fn")}
      >
        <BaselineMaps
          type={type}
          eye={eye}
          thresholds={test.thresholds}
          ntdGs={ntdGs}
          npdGs={npdGs}
          halfMaps={props.halfMaps}
        />
      </InfoWrappedMaps>
    )
  );
}
